import React, { useContext, useEffect, useState } from "react";
import cfe from "../../../services/cfe";
import AppContext from "../../../container/context";
import Form from "../../../components/form";

export default function Profissional(props) {
  const [usuarioId] = useState(Number(props.match.params.id));
  const [usuario, setUsuario] = useState({});
  const [dadosProf, setDadosProf] = useState({});
  const { notification } = useContext(AppContext);
  const history = props.history;

  useEffect(() => {
    carregarUsuario();
  }, []);

  const carregarUsuario = () => {
    cfe
      .get("admin/profissionais/carregar", { id: usuarioId })
      .then((usuario) => {
        const profissional = {
          instituicaoNomeFantasia: usuario.instituicaoNomeFantasia,
          administrador: usuario.administrador,
          inativacao: usuario.inativacao,
        };
        setDadosProf(profissional);
        setUsuario(usuario);
      })
      .catch((err) => notification("error", "Erro ao carregar o usuário"));
  };

  const salvar = (formulario) => {
    formulario.id = usuarioId;
    cfe
      .post("admin/usuarios/editar", formulario)
      .then((res) => {
        notification("success", "Dados salvos!");
        carregarUsuario();
      })
      .catch((err) => {
        console.log(err);
        const { data } = err;
        switch (data[0]) {
          case 1:
            return notification("error", "Nome inválido");
          case 2:
            return notification("error", "Email inválido");
          case 3:
            return notification("error", "CPF inválido");
          case 4:
            return notification("error", "CPF já cadastrado");
          default:
            return notification("error", "Dados inválidos");
        }
      });
  };

  const fDados = {
    title: "Dados cadastrais",
    form: {
      nome: {
        label: "Nome",
        type: "text",
        space: 4,
        value: usuario.usuarioNome,
      },
      CPF: {
        label: "CPF (apenas números)",
        type: "text",
        value: usuario.usuarioCPF,
        space: 4,
      },
      email: {
        label: "Email",
        type: "text",
        value: usuario.usuarioEmail,
        required: true,
        space: 4,
      },
    },

    submit: {
      label: "Salvar",
      action: salvar,
    },

    history,
    close: true,
  };

  const salvarProfissional = (form) => {
    const dadosEnviar = {
      id: usuario.id,
      administrador: form.administrador,
      inativacao: form.inativacao,
    };
    cfe
      .post("admin/profissionais/editar", dadosEnviar)
      .then(() => {
        notification("success", "Dados profissionais editado!");
        carregarUsuario();
      })
      .catch((err) => {
        console.log(err);
        notification("error", "Erro ao editar profissional.");
      });
  };

  const fInstituicao = {
    title: "Dados profissionais",
    form: {
      instituicaoNomeFantasia: {
        label: `Instituição`,
        type: "text",
        value: dadosProf.instituicaoNomeFantasia,
        space: 4,
        readOnly: true,
      },

      inativacao: {
        label: "Inativação",
        type: "date",
        value: dadosProf.inativacao,
        space: 4,
      },
      administrador: {
        label: "Administrador",
        type: "check",
        value: dadosProf.administrador,
        space: 4,
      },
    },
    submit: {
      label: "Salvar",
      action: salvarProfissional,
    },
  };

  return (
    <div>
      <>
        <Form formData={fDados} />
        <Form formData={fInstituicao} />
      </>
    </div>
  );
}
